import styled from '@emotion/styled';
/**
 * @fileoverview
 *
 * Styled components used for ANY kind of text cues
 */
export const CueWrapper = styled.div `
  position: absolute;
  top: ${({ top }) => top};
  left: 14px;
  width: calc(100% - 28px);
  color: white;
  text-align: left;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-content: flex-end;
  flex-wrap: wrap;
  line-height: 20px;
  max-height: 40px;
  z-index: 9999;
  background-color: var(--player-caption-background);
  color: var(--player-caption-color);
`;
export const UsernameWrapper = styled.strong `
  color: var(--business-crimson);
  margin-right: 1ch;
`;
export const TextCueWrapper = styled.span `
  box-decoration-break: clone;
  padding: 0.15em 0.35em;
`;
